export default __webpack_public_path__ + "static/media/safari_settings.14cb4d85.png";